import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ExpandKeywordInfo } from 'shared/models';
import { Region } from '@lemon8/web-app-shared/i18n';

import './style.scss';

export const RelatedExperienceInternalLinks: FC<{
  internalLinks: ExpandKeywordInfo[];
  defaultLinkRegion: string | Region;
  maxCount?: number;
}> = ({ internalLinks, defaultLinkRegion, maxCount = 15 }) => {
  const { t } = useTranslation();

  return (
    internalLinks.length > 0 && (
      <div className="related-experience-module">
        <div className="related-experience-title">{t('seo_v4_postRecommendation_title')}</div>
        <ul>
          {internalLinks.slice(0, maxCount).map((experienceItem) => {
            const { spaceKeyword, standardKeyword, region = defaultLinkRegion } = experienceItem;
            // underscoreToHyphen
            const hyphenSpaceWord = spaceKeyword.replace(/_/g, '-');
            const displayedKeyword = standardKeyword.replace(/_/g, ' ');
            return (
              <li key={hyphenSpaceWord}>
                <a
                  key={`related-experience-item-${hyphenSpaceWord}`}
                  className="related-experience-item"
                  href={`/experience/${hyphenSpaceWord}?region=${region}`}
                >
                  <strong>{displayedKeyword}</strong>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    )
  );
};
